import React from 'react';

import { EditorInput } from 'components/shared/EditorInput';

const EditorInputField = ({
  field,
  form,
  ...restProps
}: { field: any; form: any } & Record<string, any>) => {
  const handleChange = (value: any) => {
    form.setFieldValue(field.name, value);
  };

  return <EditorInput {...field} {...restProps} onChange={handleChange} />;
};

export default React.memo(EditorInputField) as any;
